const initialState = {
  ipAddress: [],
};

const ipAddressReducer = (state = initialState, action) => {
  switch (action.type) {
    case "IP_ADDRESS":
      return {
        ...state,
        ipAddress: action.payload,
      };
    default:
      return state;
  }
};

export default ipAddressReducer;
